const PLAN_NICKNAMES = import("./constants");

const products = {
    pro: {
        productId: "prod_FRozwsfXiAqlX7",
        productName: "Pro",
        unitLabel: "seat",
        plans: [
            {
                planId: "plan_FRp0E8ka77SQdm",
                amount: 1500,
                nickname: PLAN_NICKNAMES.PRO_MONTH,
                interval: "month",
                currency: "usd"
            },
            {
                planId: "plan_FRp0uyxxHheQa8",
                amount: 14400,
                nickname: PLAN_NICKNAMES.PRO_ANNUAL,
                interval: "year",
                currency: "usd",
                isDefault: true
            },
            {
                planId: "price_1KGq2WC6TOcbsMhjPPZ88t7x",
                amount: 4500,
                nickname: PLAN_NICKNAMES.PRO_MONTH_45,
                interval: "month",
                currency: "usd",
                isDefault: true
            },
            {
                planId: "price_1KGq3AC6TOcbsMhjMy8D2VEJ",
                amount: 9000,
                nickname: PLAN_NICKNAMES.PROM_MONTH_90,
                interval: "month",
                currency: "usd"
            }
        ]
    },
    team: {
        productId: "prod_HEQlgWSQkz3qGb",
        productName: "Team",
        unitLabel: "seat",
        plans: [
            {
                planId: "price_1KGq4RC6TOcbsMhjchFSsrwQ",
                amount: 5000,
                nickname: PLAN_NICKNAMES.TEAM_MONTH_50,
                interval: "month",
                currency: "usd",
                isDefault: true
            },
            {
                planId: "price_1KGq4wC6TOcbsMhjSammt9bG",
                amount: 48000,
                nickname: PLAN_NICKNAMES.TEAM_ANNUAL_480,
                interval: "year",
                currency: "usd",
                isDefault: true
            },
            {
                planId: "plan_HEQmYB4HfYaXxc",
                amount: 1500,
                nickname: PLAN_NICKNAMES.TEAM_MONTH_MIGRATED,
                interval: "month",
                currency: "usd"
            },
            {
                planId: "plan_HEQnBa6SxskXOc",
                amount: 14400,
                nickname: PLAN_NICKNAMES.TEAM_ANNUAL_MIGRATED,
                interval: "year",
                currency: "usd"
            },
            {
                planId: "plan_HEQmYB4HfYaXxb",
                amount: 4600,
                nickname: PLAN_NICKNAMES.TEAM_MONTH,
                interval: "month",
                currency: "usd"
            },
            {
                planId: "plan_HEQnBa6SxskXOb",
                amount: 45600,
                nickname: PLAN_NICKNAMES.TEAM_ANNUAL,
                interval: "year",
                currency: "usd"
            }
        ]
    },
    enterprise: {
        productId: "prod_N9QNyf6Ao1LDZl",
        productName: "Enterprise",
        unitLabel: "seat",
        plans: [
            {
                planId: "price_1Nn0LULH1BfAwD4cepFhKqI9",
                amount: 5000,
                nickname: PLAN_NICKNAMES.PRICE_ENTERPRISE_50_MONTH,
                interval: "month",
                currency: "usd",
                isDefault: true
            },
            {
                planId: "price_1Nn0JoLH1BfAwD4c9BM4Cgnn",
                amount: 48000,
                nickname: PLAN_NICKNAMES.PRICE_ENTERPRISE_480_ANNUAL,
                interval: "year",
                currency: "usd",
                isDefault: true
            }
        ]
    }
};

module.exports = products;
